import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";

import { PageAlert } from "capitalrx-components";

import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";
import { planSearchActions } from "@/App/actions";
import { GeneralTypes } from "@/types";

// transform full_text_search to plan_name because full_text_search not implemented for /plan/list
export function* searchPlan(data: GeneralTypes.QueryOptions): Generator {
  const { full_text_search, order_by, page_number, results_per_page } = data;
  return yield apiService({
    url: "/plan/list",
    method: "POST",
    data: { plan_name_or_client_id: full_text_search, order_by, page_number, results_per_page },
  });
}

export function* searchForPlanWorker(action: ReturnType<typeof planSearchActions.searchForPlans>): SagaIterator {
  const { searchForPlansResults } = planSearchActions;
  const { payload, formName } = action;
  const { showPageAlert } = PageAlert;

  try {
    yield put(startSubmit(formName));
    const { results, result_count } = yield call(searchPlan, payload);

    yield put(searchForPlansResults({ results, result_count }));
    yield put(stopSubmit(formName));
  } catch (error) {
    yield put(stopSubmit(formName));
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* searchForPlanWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.SEARCH_FOR_PLAN_LIST, searchForPlanWorker);
}
